<template>
  <div :class="{ 'h-24 load load--fill': loading }">
    <div
      v-if="folderHasContents && !loading"
      class="table-responsive"
    >
      <table class="table table-files min-w-table">
        <thead>
          <tr>
            <th
              colspan="7"
              class="table-caption"
            >
              <h2 v-text="'Favorited Documents'" />
            </th>
          </tr>
          <tr>
            <th />
            <!--<th></th>-->
            <th v-text="'Name'" />
            <th v-text="'Modified'" />
            <th v-text="'Folder'" />
            <th />
            <th v-can="'edit-documents'" />
          </tr>
        </thead>
        <tbody>
          <tr
            is="DocumentRow"
            v-for="document in favoriteDocuments"
            :key="document.uuid"
            :document="document"
          />
        </tbody>
      </table>
      <DeleteFolderModal />
      <DeleteDocumentModal />
      <MoveDocumentModal />
      <ReplaceDocumentModal />
      <DocumentHistoryModal />
    </div>
    <div
      v-if="!folderHasContents && !loading"
      class="empty"
    >
      <section>
        <h2 v-text="'You have no favorite Documents'" />
        <p>Clicking on the star next to a document will add it to this list.</p>
      </section>
    </div>
  </div>
</template>

<script type="text/babel">
import DocumentRow from './FavoriteDocumentRow'
import DeleteFolderModal from './_modals/DeleteFolderModal'
import MoveDocumentModal from './_modals/MoveDocumentModal'
import DeleteDocumentModal from './_modals/DeleteDocumentModal'
import ReplaceDocumentModal from './_modals/ReplaceDocumentModal'
import DocumentHistoryModal from './_modals/DocumentHistoryModal'

export default {
  name: 'FavoriteDocuments',
  components: {
    MoveDocumentModal,
    DeleteDocumentModal,
    DeleteFolderModal,
    DocumentHistoryModal,
    DocumentRow,
    ReplaceDocumentModal,
  },
  data() {
    return {
      loading: true,
    }
  },
  computed: {
    favoriteDocuments() {
      return this.$store.state.document.favoriteDocuments.data
    },
    folderHasContents() {
      return this.favoriteDocuments.length
    },
  },
  async mounted() {
    await this.$nextTick()

    this.$store.dispatch('documentGetFavoriteDocuments')
      .then(() => {
        this.loading = false
      })
  },
  methods: {
    openDeleteFolderModal() {
      this.$store.commit('documentOpenDeleteFolderModal', this.folder)
    },
  },
}
</script>
